import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

export default function PilihanProdi({ data }) {
  return (
    <section className="container">
      <div className="md:pr-20 md:pt-56 flex justify-end items-center">
        <div className="flex flex-col md:justify-end">
          <ScrollAnimation animateOnce={true} animateIn="fadeInRight">
            <div className="flex items-center -md:justify-end space-x-4">
              <div className="bg-purple md:w-110 md:h-4 -md:w-12 -md:h-1"></div>
              <h1 className="md:text-6xl -md:text-lg text-yellow italic font-black text-right">
                {data.title}
              </h1>
            </div>
            <h1 className="md:text-6xl -md:text-lg text-yellow italic font-black text-right">
              {data.title2}
            </h1>
            <p className="text-2xl -md:text-xs text-right">{data.subtitle}</p>
          </ScrollAnimation>
        </div>
      </div>
      <div className="grid md:grid-cols-3 grid-cols-2 gap-x-8 md:gap-y-16 -md:gap-y-8 mt-20">
        {data.items.map((item, i) => (
          <ScrollAnimation animateOnce={true} key={i} animateIn="fadeInUp">
            <a href={`#prodi${i}`}>
              <img
                src={item}
                className="transform transition-all hover:scale-105"
                alt="gambar prodi"
              />
            </a>
          </ScrollAnimation>
        ))}
      </div>
    </section>
  );
}
